import { useLanguageData } from '@/common/hooks/useLanguageData';
import { LegalText } from './PlanPayment.styles';

const PlanCheckoutLegalText = ({ prefix }) => {
	const t = useLanguageData('chat');

	return (
		<LegalText>
			{prefix}{' '}
			<a
				href='/SoftAI regulamin terms of use.pdf'
				target='_blank'
				rel='noopener noreferrer'
			>
				{t.planCheckoutTermsLink}
			</a>{' '}
			{t.planCheckoutTermsAnd}{' '}
			<a href='/PRIVACY POLICY.pdf' target='_blank' rel='noopener noreferrer'>
				{t.planCheckoutPrivacyLink}
			</a>
			.
		</LegalText>
	);
};

export default PlanCheckoutLegalText;
